import React__default from 'react';
import styles from './ProgressBar.module.scss.js';

const ProgressBar = (props) => {
    return (React__default.createElement("div", { className: styles.progressBar },
        React__default.createElement("progress", { id: "mov-bar", max: props.max, value: props.value })));
};

export { ProgressBar };
//# sourceMappingURL=ProgressBar.js.map
